import { Component, OnInit } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { dateStringFromISO8601, timeStringFromISO8601 } from '../../../../../../utils';

import { AccountService } from '../../../../../../services/account/account.service';
import { InvalidDocument } from '../../../../../../models/inbox';
import { InboxService } from '../../../../../../services/inbox/inbox.service';
import {
  ReviewInvalidDocumentModalComponent
} from './modals/review-invalid-document-modal/review-invalid-document-modal.component';
import { ViewDismissedInvalidDocumentModalComponent } from './modals/view-dismissed-invalid-document-modal/view-dismissed-invalid-document-modal.component';

@Component({
  selector: 'app-inbox-invalid-documents',
  templateUrl: './inbox-invalid-documents.component.html',
  styleUrls: ['./inbox-invalid-documents.component.css']
})
export class InboxInvalidDocumentsComponent implements OnInit {

  public activeInvalidDocuments: InvalidDocument[];
  public dismissedInvalidDocuments: InvalidDocument[];

  public loadingActiveInvalidDocuments = false;
  public loadingDismissedInvalidDocuments = false;

  public serverError: number = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public dateStringFromISO8601 = dateStringFromISO8601;
  public timeStringFromISO8601 = timeStringFromISO8601;

  constructor(
    public accountService: AccountService,
    private inboxService: InboxService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }

    this.loadActiveInvalidDocuments();
    this.loadDismissedInvalidDocuments();
  }

  public activeInvalidDocumentsPresent() {
    return this.activeInvalidDocuments && (this.activeInvalidDocuments.length > 0);
  }

  public dismissedInvalidDocumentsPresent() {
    return this.dismissedInvalidDocuments && (this.dismissedInvalidDocuments.length > 0);
  }

  public openReviewActiveInvalidDocumentModal(invalidDocument: InvalidDocument) {
    const modalRef = this.modalService.open(ReviewInvalidDocumentModalComponent);
    modalRef.componentInstance.invalidDocument = invalidDocument;
    modalRef.componentInstance.savedCallback = () => {
      this.loadActiveInvalidDocuments();
      this.loadDismissedInvalidDocuments();
    };
  }

  public openViewDismissedInvalidDocumentModal(invalidDocument: InvalidDocument) {
    const modalRef = this.modalService.open(ViewDismissedInvalidDocumentModalComponent);
    modalRef.componentInstance.invalidDocument = invalidDocument;
  }

  private loadActiveInvalidDocuments() {
    this.loadingActiveInvalidDocuments = true;

    this.inboxService
      .getActiveInvalidDocuments()
      .then(invalidDocuments => {
        this.activeInvalidDocuments = invalidDocuments;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingActiveInvalidDocuments = false; });
  }

  private loadDismissedInvalidDocuments() {
    this.loadingDismissedInvalidDocuments = true;

    this.inboxService
      .getRecentlyDismissedInvalidDocuments()
      .then(invalidDocuments => {
        this.dismissedInvalidDocuments = invalidDocuments;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingDismissedInvalidDocuments = false; });
  }

}
